import { render, staticRenderFns } from "./manage_zhkjl.vue?vue&type=template&id=2be50cb3&scoped=true"
import script from "./manage_zhkjl.vue?vue&type=script&lang=js"
export * from "./manage_zhkjl.vue?vue&type=script&lang=js"
import style0 from "./manage_zhkjl.vue?vue&type=style&index=0&id=2be50cb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be50cb3",
  null
  
)

export default component.exports